// Dashboard.jsx
import React, { useState } from 'react';
import { Outlet, useLocation, useNavigate, Link } from 'react-router-dom';
import {
  HomeIcon,
  ClockIcon,
  UsersIcon,
  BellIcon,
  MagnifyingGlassIcon,
  ChevronDownIcon,
  VideoCameraIcon,
  UserCircleIcon,
  CogIcon,
  PowerIcon,
  ChartBarIcon,
  XMarkIcon,
  Bars3Icon,
  FilmIcon
} from '@heroicons/react/24/outline';

const Admin = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [searchFocused, setSearchFocused] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const admin_info = localStorage.getItem("relay_server_info");
  let admin_data = "";
  if(admin_info != "undefined")
    {
      admin_data = JSON.parse(admin_info);
    } 

  // Check if nav item is active
  const isActive = (href) => {
    return location.pathname === href;
  };

  const handleLogout = () => {
    localStorage.removeItem('relay_server_token');
    navigate('/');
  };

  const navigation = [
    { name: 'Dashboard', href: 'dashboard', icon: HomeIcon },
    // { name: 'Studio', href: 'main-studio', icon: VideoCameraIcon },
    //{ name: 'Sessions', href: 'studio', icon: VideoCameraIcon },
    { name: 'Manage User', href: 'users', icon: UsersIcon },
    //{ name: 'Frame Time', href: 'frame-management', icon: FilmIcon },
    { name: 'Notification', href: 'notification', icon: BellIcon },
    { name: 'Logs', href: 'logs', icon: ClockIcon },
    { name: 'Settings', href: 'settings', icon: CogIcon },
  ];

  return (
    <div className="flex h-screen bg-gradient-to-br from-gray-50 to-blue-50/30">
      {/* Mobile sidebar backdrop */}
      {sidebarOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Sidebar */}
      <div className={`${
        sidebarOpen ? 'translate-x-0' : '-translate-x-full'
      } fixed inset-y-0 left-0 z-50 w-60 h-100 bg-white/95 backdrop-blur-xl shadow-2xl transform transition-all duration-300 ease-in-out lg:translate-x-0 lg:static lg:inset-0 border-r border-gray-200/60`}>
        
        {/* Logo/Header */}
        <div className="flex items-center justify-between h-20 px-6 border">
          <div className="flex items-center space-x-3">
            
            <img src="eduvsat.png" width="150"/>
          </div>
          <button
            onClick={() => setSidebarOpen(false)}
            className="lg:hidden p-2 text-white/80 hover:text-white"
          >
            <XMarkIcon className="w-5 h-5" />
          </button>
        </div>
        
        {/* Navigation */}
        <nav className="mt-8 flex-1 overflow-y-auto px-4">
          {navigation.map((item) => {
            const Icon = item.icon;
            const active = isActive(`/admin/${item.href}`);
            return (
              <Link
                key={item.name}
                to={item.href}
                className={`group flex items-center w-full px-4 py-3 mb-2 text-left transition-all duration-200 rounded-2xl ${
                  active
                    ? 'bg-gradient-to-r from-blue-500 to-purple-500 text-white shadow-lg shadow-blue-500/25'
                    : 'text-gray-600 hover:bg-white hover:shadow-lg hover:border hover:border-gray-100'
                }`}
                onClick={() => setSidebarOpen(false)}
              >
                <Icon className={`w-5 h-5 mr-3 transition-transform duration-200 ${
                  active ? 'text-white' : 'text-gray-400 group-hover:text-blue-500'
                }`} />
                <span className="font-medium">{item.name}</span>
                {active && (
                  <div className="ml-auto w-2 h-2 bg-white rounded-full" />
                )}
              </Link>
            );
          })}
        </nav>

        {/* User section at bottom */}
        <div className="p-6 border-t border-gray-200/60 bg-white/50 backdrop-blur-sm">
          
          
          <button
            onClick={handleLogout}
            className="w-full flex items-center justify-center py-3 px-4 text-sm text-gray-600 bg-white border border-gray-200 rounded-2xl hover:bg-red-50 hover:text-red-600 hover:border-red-200 transition-all duration-200 shadow-sm hover:shadow-md"
          >
            <PowerIcon className="w-4 h-4 mr-2" />
            Logout
          </button>
        </div>
      </div>

      {/* Main content */}
      <div className="flex-1 flex flex-col overflow-hidden min-w-0">
        {/* Header */}
        <header className="bg-white/80 backdrop-blur-xl border-b border-gray-200/60 shadow-sm z-10">
          <div className="flex items-center justify-between h-20 px-6">
            {/* Mobile menu button */}
            <button
              onClick={() => setSidebarOpen(!sidebarOpen)}
              className="lg:hidden p-3 rounded-2xl text-gray-600 hover:text-gray-900 hover:bg-gray-100 transition-all duration-200"
            >
              <Bars3Icon className="w-6 h-6" />
            </button>

            {/* Breadcrumb */}
            <div className="hidden md:flex items-center space-x-3">
              <span className="text-sm text-gray-500">Admin</span>
              <ChevronDownIcon className="w-4 h-4 transform -rotate-90 text-gray-400" />
              <span className="text-sm font-semibold text-gray-900 bg-blue-50 px-3 py-1 rounded-full">
                {navigation.find(item => location.pathname.includes(`/admin/${item.href}`))?.name || 'Dashboard'}
              </span>
            </div>

            {/* Search bar */}
            <div className="flex-1 max-w-2xl mx-8">
              <div className={`relative transition-all duration-300 ${
                searchFocused ? 'scale-105' : 'scale-100'
              }`}>
                <MagnifyingGlassIcon className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                <input
                  type="text"
                  placeholder="Search anything..."
                  className="w-full pl-12 pr-6 py-3 bg-gray-100/80 border-0 rounded-2xl focus:ring-2 focus:ring-blue-500 focus:bg-white focus:shadow-lg transition-all duration-300"
                  onFocus={() => setSearchFocused(true)}
                  onBlur={() => setSearchFocused(false)}
                />
              </div>
            </div>

            {/* Notifications & User */}
            <div className="flex items-center space-x-3">
              
              
              <div className="flex items-center space-x-3 p-2 rounded-2xl hover:bg-gray-100/80 cursor-pointer transition-all duration-200">
                <div className="relative">
                  <UserCircleIcon className="w-10 h-10 text-gray-600" />
                  <div className="absolute bottom-0 right-0 w-3 h-3 bg-green-500 rounded-full border-2 border-white"></div>
                </div>
                <div className="hidden lg:block">
                  <p className="text-sm font-medium text-gray-900 capitalize">{admin_data.name}</p>
                  <p className="text-xs text-gray-500">Online</p>
                </div>
                <ChevronDownIcon className="w-4 h-4 text-gray-400" />
              </div>
            </div>
          </div>
        </header>

        {/* Main content area */}
        <main className="flex-1 overflow-y-auto p-6 bg-transparent">
          <div className="max-w-7xl mx-auto">
            <div className="bg-white/80 p-6 backdrop-blur-sm rounded-3xl shadow-sm border border-gray-200/60 min-h-[calc(100vh-8rem)]">
              <Outlet />
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default Admin;